import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import {ReferentialService} from "../../../../../shared/services/referential/referential.service";
import {Subscription} from "rxjs/index";
import {ToastrService} from "ngx-toastr";
import {environment} from "../../../../../../environments/environment";
import {ProjectService} from "../../../../../shared/services/project/project.service";
import {faClock, faPlus, faProjectDiagram} from "@fortawesome/free-solid-svg-icons";
import {TranslateService} from "@ngx-translate/core";
import {StatesService} from "../../../../../shared/services/state/states.service";
import {map} from "rxjs/internal/operators";
import {ProjectDeviceAssignementComponent} from "./modals/project-device-assignement/project-device-assignement.component";
import {ProjectDeviceAssignement} from "../../../../../shared/classes/project-device-assignement/project-device-assignement";
import {SchedulerSpcuComponent} from "../../../../../shared/components/scheduler-spcu/scheduler-spcu.component";
import {ModalService} from '../../../../../shared/services/modal/modal.service';

@Component({
    selector: 'app-project-device',
    templateUrl: './project-device.component.html',
    styleUrls: ['./project-device.component.css']
})
export class ProjectDeviceComponent implements OnInit, OnDestroy {

    public displayedColumns: string[] = ['id', 'parentName', 'name', 'deviceType', 'deviceAssigned', 'action'];
    public projectDevices: any[] = [];
    public countLocations: number = null;
    public pageSizeOptions = environment.pageSizeOptions;
    public pageSize = environment.pageSize;
    public showSpinner: boolean = false;
    public faPlus = faPlus;
    public faClock = faClock;
    public faProjectDiagram = faProjectDiagram;

    public deviceTypes = [];
    public unitList = [];
    public readMode: boolean = true;
    public openedPanel: number = -1;
    public generateLocationPreference = false;

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @Input('projectId') projectId: number = null;
    @Input('readOnly') readOnly: boolean;


    private reloadProjectDevice: Subscription;

    constructor(private projectService: ProjectService,
                private statesService: StatesService,
                private toastr: ToastrService,
                private translate: TranslateService,
                private modalService: ModalService,
                private referentialService: ReferentialService) {
    }

    ngOnInit() {
        this.initUnit();
        this.reloadProjectDevice = this.statesService.reloadProjectDevice
            .subscribe(
                () => {
                    this.initList();
                }
            );
    }

    async openModal() {
        const modalRef = this.modalService.openNgbModal(ProjectDeviceAssignementComponent, {size: 'lg'});
        const componentInstance: ProjectDeviceAssignementComponent = modalRef.componentInstance;
        componentInstance.projectId = this.projectId;
        componentInstance.generateLocationPreference = this.generateLocationPreference;
        this.generateLocationPreference = await modalRef.result;
    }

    openScheduler(deviceId: number) {
        const modalRef = this.modalService.openNgbModal(SchedulerSpcuComponent, {size: 'lg'});
        modalRef.componentInstance.deviceId = deviceId;
    }

    ngOnDestroy() {
        this.reloadProjectDevice.unsubscribe();
    }

    changeLockerValue() {
        this.readMode = !this.readMode;
    }

    removeProjectDeviceAssignement(id: number) {
        this.showSpinner = true;
        this.projectService.deleteProjectDeviceAssignement(id, false)
            .subscribe(
                (data: any) => {
                    this.initList()
                    this.toastr.success(this.translate.instant('REMOVED_DEVICE_PROJECT'), this.translate.instant('SUCCESS'));
                    this.showSpinner = false;
                }
                ,
                error2 => {
                    this.showSpinner = false;
                }
            )
    }


    setOpened(index: number) {
        this.openedPanel = index;
    }

    isOpen(index: number) {
        return this.openedPanel === index;
    }

    patchProjectDeviceAssignement(assignementId: number, name: string, dyndns: string = null) {
        if (name.length > 0) {
            if (name.length > 3) {

                this.showSpinner = true;
                let projectDeviceAssignement = new ProjectDeviceAssignement();
                projectDeviceAssignement.name = name;
                if (dyndns) projectDeviceAssignement.dyndns = dyndns;
                this.projectService.patchProjectDeviceAssignement(assignementId, projectDeviceAssignement)
                    .subscribe(
                        (data: any) => {
                            this.showSpinner = false;
                            this.initList();
                            this.toastr.success(this.translate.instant('MODIFIED_DEVICE_INFOS'), this.translate.instant('SUCCESS'));
                            this.statesService.reloadProjectDevice.next();

                        }
                        ,
                        error2 => {
                            this.showSpinner = false;
                        }
                    )

            } else {
                this.toastr.error(this.translate.instant('DEVICE_NAME_TOO_SHORT'), this.translate.instant('ERROR'));
            }
        }
        else {

            this.toastr.error(this.translate.instant('DEVICE_NAME_MANDATORY'), this.translate.instant('ERROR'));
        }

    }

    private initUnit() {
        this.showSpinner = true;
        this.referentialService.getUnits().subscribe((data: any) => {
            this.unitList = data;
            this.initReferentialData();
        }, error2 => {
            this.showSpinner = false;


        });

    }

    private initReferentialData() {
        this.showSpinner = true;
        this.referentialService.getDeviceTypes().pipe(map((data: any) => {
                data.forEach((d) => {
                    d.value = d.id;
                    delete d.id;
                    d.name = d.type;
                    delete d.type;
                });
                return data;
            })
        ).subscribe((data: any) => {
            this.deviceTypes = data;
            this.initList();
        }, error2 => {
            this.showSpinner = false;
        });
    }


    private initList() {

        if (!isNaN(this.projectId)) {
            this.showSpinner = true;
            this.projectService.getProject(this.projectId, 'locations,devices')
                .subscribe(
                    (data: any) => {

                        this.countLocations = data.project_device_assignements.length;
                        this.projectDevices = data.project_device_assignements;

                        this.showSpinner = false;
                    },
                    (error2) => {
                        this.showSpinner = false;
                    }
                );
        } else {
            this.projectId = null;
        }

    }

}
